import * as React from "react";
import { actionByLabel } from "../../actions";
import { Dispatch } from "redux";
import { connect } from "react-redux";

interface IProps {
  inverse?: boolean;
  label: string;
  section: string;
  year?: string;
  action: any;
}

const SlideoutButton = (props: IProps) => {

  return (
  <button
    className={`${
      props.inverse ? "text-white" : "text-cct-blue"
    } font-montserrat font-bold text-sm`}
    
    onClick={() => {props.action( props.label, props.section, props.year )}}
  >
    {props.label}{" "}
    <i
      className={`${
        props.inverse
          ? "text-white border-white"
          : "border-cct-blue text-cct-blue"
      } ml-2 leading-normal fa fa-info border-2 rounded-full w-6 h-6`}
    />
  </button>
  )
    };

const mapDispatchToProps = (dispatch: Dispatch) => ({
      action: (label: string, section: string, year?: string) => dispatch( 
        actionByLabel( 
          label, 
          section,
          year
        )
      )
});

export default connect(
  null,
  mapDispatchToProps
)(SlideoutButton)



// WEBPACK FOOTER //
// ./src/components/general/SlideoutButton.tsx